import { render, staticRenderFns } from "./listFiltro.vue?vue&type=template&id=54ecb1c6&"
import script from "./listFiltro.vue?vue&type=script&lang=js&"
export * from "./listFiltro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports